// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"4520":"d07ae769","6369":"19f59168"}[chunkId] + ".chunk.css");